import $ from 'jquery';
import './../less/main.less';
import './../fonts/linearicons.less';

console.log('hello');


/** WEBPACK FOOTER **
 ** ./src/js/main.js
 **/